import axios from 'axios';

const { REACT_APP_STAGE, REACT_APP_API_BASE_URL } = process.env;

// Use local development URL if available, otherwise use production URL
const baseURL = REACT_APP_API_BASE_URL || `https://v2.transrec.net/2022-05/back/${REACT_APP_STAGE}`;

const v2api = axios.create({
  baseURL: baseURL,
});

const v2apiBlob = axios.create({
  baseURL: baseURL,
  responseType: 'blob',
});

export { v2api, v2apiBlob };
